import { Button, Toolbar } from "devextreme-react";
import { Item } from "devextreme-react/toolbar";
import React from "react";
import { DataMap, enums } from "../../base";
import { CpNewModel } from "../../models";

export interface CpNewToolbarProps {
    permissions: DataMap<boolean>;
    onButtonClick: (model: CpNewModel, name: string) => void;
    onContextButtonClick: (ids: number[], name: string) => void;
}

interface CpNewToolbarState {
    model: CpNewModel;
    ids: number[];
}

export default class CpNewToolbar extends React.Component<CpNewToolbarProps, CpNewToolbarState> {
    constructor(props: Readonly<CpNewToolbarProps>) {
        super(props);

        this.state = {
            model: {},
            ids: []
        }
    }

    setModel(model: CpNewModel) {
        this.setState({ model: model });
    }

    setIds(ids: number[]) {
        this.setState({ ids: ids });
    }

    render(): React.ReactNode {
        const { model, ids } = this.state;
        const permissions = this.props.permissions || {};

        return (
            <div className={"page-toolbar"}>
                <Toolbar>
                    <Item location={"after"} locateInMenu={"auto"} visible={!!permissions[enums.stdActions.create]}>
                        <Button
                            text="新增"
                            onClick={() => this.props.onButtonClick({}, "add")} />
                    </Item>
                    <Item location={"after"} locateInMenu="auto" visible={!!permissions[enums.stdActions.update]}>
                        <Button
                            disabled={!model.id}
                            text="编辑"
                            onClick={() => this.props.onButtonClick(model, "edit")} />
                    </Item>
                    <Item location={"after"} locateInMenu="auto" visible={!!permissions[enums.stdActions.delete]}>
                        <Button
                            disabled={!ids.length}
                            text="批量删除"
                            onClick={() => this.props.onContextButtonClick(ids, "delete")} />
                    </Item>
                </Toolbar>
            </div>
        );
    }
}